export default __webpack_public_path__ + "34726b92de00ef36a666fce680ab8858.png";